import { render, staticRenderFns } from "./TagsPanel.vue?vue&type=template&id=3f4c70c8&scoped=true"
import script from "./TagsPanel.vue?vue&type=script&lang=js"
export * from "./TagsPanel.vue?vue&type=script&lang=js"
import style0 from "./TagsPanel.vue?vue&type=style&index=0&id=3f4c70c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4c70c8",
  null
  
)

export default component.exports